<template>
  <div>
    <bq-header />
    <div class="content-wrapper">
      <div class="search-wrapper wrapper" data-aos="fade-down">
        <!-- <input type="text" placeholder="输入搜素内容" class="search-wrapper-input"> -->
        <div style="margin-top: 0px">
          <el-input
            placeholder="请输入内容"
            v-model="input2"
            :class="input2 ? 'active2' : ''"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
            <!-- <template slot="append">.com</template> -->
          </el-input>
          <div style="margin-top: 8px; padding-left: 18px" class="search-tag">
            人气搜索：
            <span
              @click="select(item)"
              v-for="(item, index) in shortSearch"
              :key="'0' + index"
              class="pointer"
            >
              {{ item }}
            </span>
          </div>
        </div>
      </div>
      <div class="list-wrapper wrapper">
        <div class="list-tag clearfix">
          <div class="tag-left" v-show="showResult || list.length || showBlack">
            {{ showInput }}
          </div>
          <div class="tag-right">
            {{ showResult ? (list.length ? "搜索结果" : "暂无搜索结果") : "" }}
          </div>
        </div>
        <div class="list-content">
          <div
            class="list-item img-wrapper img-animate"
            @click="toDetail(item)"
            :class="index % 2 ? '' : 'mr'"
            v-for="(item, index) in list"
            :key="index"
            data-aos="fade-up"
            data-aos-delay="0.2"
          >
            <img :src="item.imgSrc" alt="" />
            <div class="list-item-txt line1">
              {{ item.workName + " " }}{{ " " + item.workEname }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <bq-footer></bq-footer>
  </div>
</template>

<script>
import bqHeader from "@/view/V2/components/header.vue";
// import bqFooter from "@/view/V2/components/footer.vue";
import bqFooter from "@/components/tail";
import "aos/dist/aos.css";
import AOS from "aos/dist/aos.js";
export default {
  components: {
    bqHeader,
    bqFooter,
  },
  data() {
    return {
      shortSearch: ["美术", "摄影"],
      defaultImg:
        "https://img2.baidu.com/it/u=3635204433,939208923&fm=253&fmt=auto&app=138&f=JPEG?w=375&h=500",
      input2: "",
      showInput: "",
      list: [],
      showResult: false,
      showBlack: true,
      temp: "",
    };
  },
  // watch: {
  //   $route(to, from) {
  //     //当参数改变时就会触发比方法，以此达到数据属性
  //     this.input2 = this.$route.query.searchKey;

  //     this.getData();
  //   },
  // },
  created() {
    AOS.init({
      offset: 10,
      duration: 600,
      easing: "ease-in-sine",
      delay: 100,
    });
    console.log("3");
    if (this.$route.query && this.$route.query.searchKey) {
      this.input2 = this.$route.query.searchKey;
      this.showResult = true;
      this.goSearch();
      console.log("1");
    } else if (this.$route.query && this.$route.query.type) {
      this.temp = this.$route.query.type;

      this.showResult = false;
      this.goSearch();
      console.log("2");
    } else {
      this.showBlack = false;
    }

    console.log(this.$route.query.searchKey);
  },
  methods: {
    select(item) {
      this.input2 = item;
      this.$router.push({ path: "/search", query: { searchKey: this.input2 } });
      this.showResult = true;
      this.goSearch();
    },
    search() {
      if (this.input2 != "") {
        this.$router.push({
          path: "/search",
          query: { searchKey: this.input2 },
        });
        this.showResult = true;
        this.goSearch();
      } else {
        this.$message.warning("请输入关键词");
      }
    },
    goSearch() {
      if (this.temp) {
        this.showInput = this.temp;
        this.temp = "";
      } else {
        this.showInput = this.input2;
      }

      this.getData();
    },
    toDetail(item) {
      console.log(item);
      this.$router.push({ path: "/workDetails", query: { id: item.id,workId: item.workId} });
    },
    async getData() {
      var item = {};
      console.log(this.input2);
      console.log(this.input2 != "");

      console.log(this.temp);
      if (this.input2 != "" || this.$route.query.searchKey) {
        item = {
          workName: this.input2,
        };
      } else {
        item = {
          typeName: this.showInput,
        };
      }
      var list = await this.$getHttp("pc/tShow/list", {
        ...item,
      });
      this.list = list.list.map((item, index) => {
        return {
          imgSrc: this.$baseUrl + item.aimg,
          id: item.id,
          workName: item.workName,
          workEname: item.workEname,
          workId:item.workId
        };
      });
    },
  },
};
</script>

<style lang="less" scoped>
.mask {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0%;
  // background-color: rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

img,
.item-txt-lr,
.mask {
  transition: all 0.5s;
}
@keyframes show {
  0% {
    height: 0%;
  }
  100% {
    height: 100%;
  }
}
@keyframes close {
  0% {
    height: 100;
  }
  100% {
    height: 0%;
  }
}
.img-animate:hover img {
  transform: scale(1.05);
}
.img-animate:hover .mask {
  // animation: show 300ms;
  // animation-fill-mode: forwards;
  height: 100%;
}
.img-animate:hover .list-item-txt {
  opacity: 1;
}
.img-animate .list-item-txt {
  opacity: 0;
}

.img-wrapper {
  position: relative;
  height: 100%;
  overflow: hidden;
  border-radius: 16px 16px 16px 16px;
  cursor: pointer;
}
.img-wrapper.swiper-img {
  position: relative;
  height: 100%;
  overflow: hidden;
  border-radius: 16px 16px 16px 16px;
}
.pointer {
  cursor: pointer;
}
/deep/ .el-input__inner {
  font-size: 28px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  height: 64px;
  line-height: 64px;
}
/deep/ .el-input-group__append {
  width: 94px;
  text-align: center;
  .el-icon-search {
    font-weight: 600;
    font-size: 32px;
  }
}

/deep/ .active2 .el-input__inner {
  font-size: 28px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #333 !important;
  height: 64px;
  line-height: 64px;
}
.mr {
  margin-right: 64px;
}
.clearfix:after {
  content: "020";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  /* 触发 hasLayout */
  zoom: 1;
}
.bqv2-index {
  position: relative;
  overflow: hidden;
  color: #333333;
}
.wrapper {
  width: 1200px;
  margin: 0 auto;
}
.content-wrapper {
  min-width: 1440px;
  padding-top: 43px;
  margin-bottom: 115px;
  .search-wrapper {
    width: 846px;
    // height: 46px;
    margin: 0 auto;
    .search-wrapper-input {
      position: relative;
      outline: 1px;
      outline-color: #333333;
    }
    .search-tag {
      //   width: 242px;
      height: 25px;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;
      line-height: 1;
    }
  }
  .list-wrapper {
    margin-top: 67px;
    .list-tag {
      color: #ffffff;
      .tag-left {
        float: left;
        // width: 284px;
        padding: 0 62px;
        height: 100px;
        line-height: 100px;
        text-align: center;
        background: #000000;
        border-radius: 90px 90px 90px 90px;
        opacity: 1;
        margin-right: 20px;

        font-size: 40px;
      }
      .tag-right {
        float: left;
        // width: 120px;
        // height: 42px;
        font-size: 30px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        height: 100px;
        line-height: 100px;
      }
    }
    .list-content {
      margin-top: 50px;
      .list-item {
        width: 568px;
        height: 698px;
        display: inline-flex;
        border-radius: 16px 16px 16px 16px;
        margin-bottom: 64px;

        position: relative;
        overflow: hidden;
        .list-item-txt {
          position: absolute;
          bottom: 30px;
          left: 30px;
          right: 30px;
          height: 40px;
          font-size: 28px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 40px;
          // letter-spacing: 30px;F
          // -webkit-text-stroke: 1px #FFFFFF;
          // text-stroke: 1px #FFFFFF;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/V2/searchResult.vue